<template>
  <div class="moreinfo mb-5">
    <div class="moreinfo-overlay" @click="closeMoreInfo"></div>
    <div class="moreinfo-content" v-if="ages !== ''">
      <div class="row">
        <div class="col-md-12">
          <div v-html="ages"></div>
        </div>
      </div>
      <div @click="closeMoreInfo" class="moreinfo-close btn-delete">
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        ages: ''
      }
    },
    name: "AgeTable",
    methods: {
      closeMoreInfo() {
        this.$emit('closeClicked',false);
      }
    },
    created() {
      var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.loadingContainer,
          canCancel: true,
          onCancel: this.onCancelLoading,
          opacity: 0.7,
      });
      loader;
      this.axios
      .post(this.url +  "/index.php?id=491")
      .then((response) => {
        this.status = response.status;
        this.ages = response.data;
        loader.hide();
      });
    }
  }
</script>
